import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap } from "@angular/router";
import { ProductService } from "../../services/product.service";
import { CartService } from "../../services/cart.service";
import { map } from "rxjs/operators";
import { environment } from 'src/environments/environment';
import { ProductModelServer, ServerResponse } from 'src/app/models/product.model';
import { Router } from '@angular/router';

declare let $: any;

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']  
})
export class ProductComponent implements OnInit, AfterViewInit {
  imageBaseUrl = environment.imageBaseUrl;

  id: number;
  product;
  thumbimages: any[] = [];
  @ViewChild('quantity') quantityInput;
  products: ProductModelServer[] = [];
  categories: any[] = [];
  categoryId: number;
  categoryName: string;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private productService: ProductService,
              private cartService: CartService) { }

  ngOnInit(): void {

          // get all products
        this.productService.getAllProducts().subscribe((prods: ServerResponse) => {
              this.products = prods.products.slice(0,4);
            });


        
    // NEW CODE ADDED //
    const slugWithId = this.route.snapshot.params['slugAndId'];
    const id = this.extractId(slugWithId);

    if (id) {
      this.productService.getSingleProduct(id).subscribe(prod => {
        this.product = prod;

        try {
          // Try parsing JSON
          const parsed = JSON.parse(prod.images);
          this.thumbimages = Array.isArray(parsed) ? parsed : [prod.image];
        } catch (e) {
          // If not JSON, try splitting string by comma
          this.thumbimages = prod.images ? prod.images.split(',') : [prod.image];
        }

        console.log('Thumb Images:', this.thumbimages);
      });
    } else {
      console.error('Invalid product ID in URL:', slugWithId);
    }
      // NEW CODE ADD END HERE//

    // Get product from category
        // const slug = this.route.snapshot.params['slugAndId']; // e.g., 'accent-chairs'
        // this.categoryName = this.slugToTitle(slug);

        // this.productService.getProductsFromCategory(this.categoryName).subscribe({
        //     next: (res: ServerResponse) => {
        //         this.products = res.products;
        //     },
        //     error: (err) => {
        //         console.error('Failed to fetch products:', err);
        //     }
        // });
    
    // this.route.paramMap.pipe(map((param: ParamMap) => {
    //     // @ts-ignore
    //     return param.params.id;
    //   })
    // ).subscribe(prodId => {
    //   this.id = prodId;
    //   this.productService.getSingleProduct(this.id).subscribe(prod => {
    //     this.product = prod;
    //     if (prod.images !== null) {
    //       this.thumbimages = prod.images.split(';');
    //     }

    //   });
    // });
  }

    selectProduct(id: Number) {
        this.router.navigate(['product', id]).then();
    }

 // Convert slug to Title: 'accent-chairs' → 'Accent Chairs'
    slugToTitle(slug: string): string {
        return slug
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize
            .join(' ');
    }
    
  extractId(slug: string): number {
    const parts = slug.split('-');
    return parseInt(parts[parts.length - 1], 10);
  }
  
  ngAfterViewInit(): void {
    // Product Main img Slick
    $('#product-main-img').slick({
      infinite: true,
      speed: 300,
      dots: false,
      arrows: true,
      fade: true,
      asNavFor: '#product-imgs',
    });

    // Product imgs Slick
    $('#product-imgs').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      centerMode: true,
      focusOnSelect: true,
      centerPadding: 0,
      vertical: true,
      asNavFor: '#product-main-img',
      responsive: [{
        breakpoint: 991,
        settings: {
          vertical: false,
          arrows: false,
          dots: true,
        }
      },
      ]
    });

    // Product img zoom
    var zoomMainProduct = document.getElementById('product-main-img');
    if (zoomMainProduct) {
      $('#product-main-img .product-preview').zoom();
    }
  }

   // Convert slug to Title: 'accent-chairs' → 'Accent Chairs'
  getSlug(name: string): string {
    return name.toLowerCase().replace(/\s+/g, '-');
  }

  AddToCart(id: number) {
    this.cartService.AddProductToCart(id);
  }


  Increase()
  {
    let value = parseInt(this.quantityInput.nativeElement.value);
    if (this.product.quantity >= 1)
    {
      value++;

      if (value > this.product.quantity) value = this.product.quantity;
    }
    else return;

    this.quantityInput.nativeElement.value = value.toString();
  }

  Decrease()
  {
    let value = parseInt(this.quantityInput.nativeElement.value);
    if (this.product.quantity > 0)
    {
      value--;

      if (value <= 1)  value = 1;
    }
    else return;

    this.quantityInput.nativeElement.value = value.toString();
  }

}
